import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SensorsService } from '../../services/sensors.service';
import { Toaster } from 'ngx-toast-notifications';
import Sensor from '../../models/sensor';

@Component({
  selector: 'app-delete-sensor-dialog',
  templateUrl: './delete-sensor-dialog.component.html',
  styleUrls: ['./delete-sensor-dialog.component.scss']
})
export class DeleteSensorDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DeleteSensorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sensorService: SensorsService,
    private toaster: Toaster) { }

  public sensorID: number;
  public serial: number;
  private sensor: Sensor;
  public inputOfSensorSerial: any;
  private deletionData: any;
  public realCheck: boolean = false;
  public buttonEnabled: boolean = false;
  private valueEntered: any;

  ngOnInit() {
    this.sensorID = Number(this.data.sensorID)
    this.serial = Number(this.data.serial)
    this.sensor = new Sensor()
    this.sensor = this.data
    this.sensor.data = {}
    this.sensor.data.id = this.sensorID
    this.sensor.data.type = 'sensor'
    this.sensor.data.attributes = {}
    this.sensor.data.attributes.active = false;
    this.sensor.data.attributes.serial = this.data.serial
  }

  // The commented code in the following methods is done due to
  // the fact that we didn't want the double check procedure
  // We commented the corresponding template elements in the html.

  delete() {
    // if (!this.buttonEnabled) return
    if (!this.realCheck) return
    this.deleteSensor()
  }

  deleteSensor() {
    console.log(this.sensor)
    this.sensorService.patchSensor(this.sensor).subscribe(
      res => {
        this.deletionData = { ...res }
      },
      error => {
        this.toaster.open({
          caption: 'Error in deletion',
          text: 'Something went wrong',
          type: 'warning'
        })
      },
      () => {
        this.dialogRef.close({ "intention": 1 })
        this.toaster.open({
          caption: 'Successful deletion',
          text: `The sensor with ID: ${this.sensorID} has been deleted`,
          type: 'success'
        })
      })
  }

  checkValueEntered(value: any) {
    this.valueEntered = value;
    if (Number(this.valueEntered) === this.serial) this.realCheck = true;
    else this.realCheck = false;
  }

  checkIfValueIsEmpty(value: any) {
    this.valueEntered = value;
    if (Number(this.valueEntered) === this.serial) this.realCheck = true;
    else this.realCheck = false;
  }

  cancel() {
    this.dialogRef.close({ "intention": 0 })
  }

  check(sensorSerial) {
    if (this.realCheck) {
      if (sensorSerial === undefined || sensorSerial === null || sensorSerial === '') {
        // this.buttonEnabled = false;
        this.toaster.open({
          caption: 'Warning',
          text: 'Enter the ID of the sensor in the field',
          type: 'warning'
        })
      }
      // if (Number(sensorSerial) === this.serial) {
      //   // this.buttonEnabled = true;
      // }
    } else return
  }

}
